module.exports = __webpack_public_path__ + "img/logo.c871f0d4.png";